import { useLingui } from "@lingui/react";
import { RelativeTimeOption } from "../types";
import { FC } from "react";
import { Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { RELATIVE_TIME_OPTIONS } from "@/constants/dateTimeRangePicker.constants";
import { CalendarMonth } from "@mui/icons-material";

interface RelativeTimeListProps {
  hideAbsoluteTime: boolean;
  openAbsolute: boolean;
  selectedRelativeTime: string;
  onSelectRelativeTime: (option: RelativeTimeOption) => void;
}

export const RelativeTimeList = ({
  hideAbsoluteTime,
  openAbsolute,
  selectedRelativeTime,
  onSelectRelativeTime
}: RelativeTimeListProps) => {
  const { _ } = useLingui();

  return (
  <List sx={{ display: 'flex', flexDirection: 'column', py: 0 }}>
    {!hideAbsoluteTime && (
      <ListItem
        disableGutters
        disablePadding
        sx={
          openAbsolute
            ? {
              border: 1,
              borderRight: 0,
              borderColor: 'text.secondary',
              borderRadius: '4px 0 0 4px',
              backgroundColor: 'background.paper',
              my: '-1px',
              mx: 0,
            }
            : undefined
        }
      >
        <ListItemButton
          onClick={() => {onSelectRelativeTime(RELATIVE_TIME_OPTIONS[0])}}
          autoFocus={openAbsolute || selectedRelativeTime === 'absolute'}
          selected={openAbsolute || selectedRelativeTime === 'absolute'}
        >
          <ListItemText primary={_(RELATIVE_TIME_OPTIONS[0].label)} />
          <ListItemIcon sx={{ mr: 0, ml: 4 }}>
            <CalendarMonth color="info" />
          </ListItemIcon>
        </ListItemButton>
      </ListItem>
    )}
    <Box sx={{ overflowY: 'auto' }} flexGrow={1} className="custom-scrollbar">
      {RELATIVE_TIME_OPTIONS
        .filter((option) => option.value !== 'absolute')
        .map((option) => (
          <ListItem key={option.value} disableGutters disablePadding>
            <ListItemButton
              onClick={() => {onSelectRelativeTime(option)}}
              autoFocus={!openAbsolute && selectedRelativeTime === option.value}
              selected={!openAbsolute && selectedRelativeTime === option.value}
            >
              <ListItemText primary={_(option.label)} />
            </ListItemButton>
          </ListItem>
        ))
      }
    </Box>
  </List>

  );
}

